export const formatPortDisplayText = (portDetails) => {
  const { name, city, country } = portDetails;
  return `${name}, ${city}, ${country}`;
};
